import { useState, useEffect } from 'react';

/**
 * Custom hook to detect if the current view should be considered mobile
 * based on both user agent and viewport width
 * @returns boolean indicating if the current view is mobile
 */
export function useIsMobile(): boolean {
  // Check if user agent is mobile
  const isMobileDevice = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  // Initialize with current window width
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    // Handler to call on window resize
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Call handler right away so state gets updated with initial window size
    handleResize();

    // Remove event listener on cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []); // Empty array ensures that effect is only run on mount and unmount

  // Consider mobile if either user agent is mobile OR viewport width is below threshold
  const isMobileWidth = windowWidth <= 768; // Match with $breakpoint-mobile in SCSS

  return isMobileDevice || isMobileWidth;
}

export default useIsMobile;
